import { icsApi } from './api';
import { getFilenameFromContentDisposition } from './utils';

interface Params {
  url: string;
}

// TODO: currently limited to pdf files, consider adding support for other file types
export async function getFile({ url }: Params): Promise<void> {
  const axiosResponse = await icsApi.get(url, {
    responseType: 'blob',
  });

  // TODO: consider zod for validation
  const contentType = String(axiosResponse.headers['content-type'] ?? '');
  const contentDisposition = String(axiosResponse.headers['content-disposition'] ?? '');
  if (axiosResponse.status !== 200 || !contentType) {
    throw new Error();
  }

  const filename = getFilenameFromContentDisposition(contentDisposition ?? '');
  const blob = axiosResponse.data;

  const downloadElem = document.createElement('a');
  downloadElem.download = filename;
  downloadElem.href = URL.createObjectURL(blob);
  downloadElem.click();

  URL.revokeObjectURL(downloadElem.href);
  downloadElem.remove();
}
